import React from "react";
import { Fab, Tooltip } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

export default function PATViewButton(props) {
  const {
    onClick,
    disabled,
    size,
    tooltipText,
    entityFlag,
    viewOnly,
    className,
  } = props;

  if (entityFlag === "tags" && viewOnly) {
    return null;
  }

  const button = (
    <Fab
      size="small"
      disabled={disabled}
      color="secondary"
      aria-label="delete"
      onClick={onClick}
      className={className || ""}
    >
      <RemoveRedEyeIcon style={{ fontSize: size }} />
    </Fab>
  );

  return (
    <Tooltip title={tooltipText || "View"}>
      {disabled ? <span>{button}</span> : button}
    </Tooltip>
  );
}
